export default function({ data }) {
  return <section className='flex flex-col justify-center items-center'>
    <a href="https://beian.miit.gov.cn/" target="_blank"> 黔ICP备2022009741号-1</a>
    <span className='p-1'>©2023 {data.title} （version by {data.version} alpha） All rights reserved.</span>
  </section>
}
